<template>
  <div>
    <vm-table ref="vmTable" url="periodicInspectionTemplate" :filter.sync="search">
      <template slot="adSearch">
        <vm-search label="关键字检索">
          <el-input v-model.trim="search.filter" :placeholder="$t('common.search')" clearable></el-input>
        </vm-search>
      </template>
      <template slot="toolbar">
        <el-button class="addBtn" @click="$refs.checkTemplatesEdit.open()">
          {{ $l("common.add", "+ 新增") }}
        </el-button>
      </template>
      <el-table-column prop="templateNo" label="模板编号" width="120" align="center"></el-table-column>
      <el-table-column prop="templateName" label="模板名称" show-overflow-tooltip></el-table-column>
      <el-table-column v-if="userType === 0" prop="orgName" label="所属企业" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140" align="center"></el-table-column>
      <el-table-column prop="creator" label="创建人" width="120" align="center"></el-table-column>
      <el-table-column prop="isDefault" label="是否默认" width="80" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="!scope.row.isDefault">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="$refs.checkTemplatesEdit.open(scope.row.id)">编辑</el-button>
          <el-button class="operateDelBtn" type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <check-templates-edit ref="checkTemplatesEdit" @save-success="getList(1)"></check-templates-edit>
  </div>
</template>

<script>
import CheckTemplatesEdit from "./checkTemplatesEdit.vue";
import auth from "@/util/auth";
export default {
  components: { CheckTemplatesEdit },
  data() {
    return {
      userType: auth.getUserType(),
      search: {
        filter: "",
      },
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    getList(pageNum) {
      this.$refs.vmTable.getList(pageNum);
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确认删除吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.$http
          .delete("periodicInspectionTemplate", row.id)
          .then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      });
    },
  },
};
</script>
